import { Dialog } from '@material-ui/core'
import React from 'react'
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import "../../../LangConfig";

const FlightTypeErrorHandling = ({flightTypeOptionCheck,handleBackToLogin}) => {
  const { t } = useTranslation();
  const isInternalUserAutheticated = useSelector((state) => state.internalUser.isInternalUserAutheticated);
  return (
    <Dialog
        open={flightTypeOptionCheck}
        keepMounted
        onClose={handleBackToLogin}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
        >
        <div className="bd-pi-contact-modal bd-alertBox bd-paxType-Validation">
            {isInternalUserAutheticated ?
            <span>{t("Flight_type_connectivity_error_logout")}</span>
             :
            <span>{t("Flight_type_connectivity_error_gigi")}</span>
            }
            <div className="btn-wrapper">
            <button className="yes" onClick={handleBackToLogin}>Ok</button>
            </div>
        </div>
   </Dialog> 
  )
}

export default FlightTypeErrorHandling